var app = angular.module('leonardo');

var DocumentFileRequirementName = function () {
  return function (pk, list) {
    if (!pk || !list) return '';
    var name = '';
    angular.forEach(list, function(requirement) {
      if (requirement.id == pk) name = requirement.name;
    });
    return name;
  }
};

app.filter('documentFileRequirementName', [DocumentFileRequirementName]);
